import {
  type HttpEvent,
  type HttpHandler,
  type HttpInterceptor,
  type HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { type Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ConfigurationService } from '../services/configuration.service';

@Injectable()
export class TestTokenInterceptor implements HttpInterceptor {
  constructor(private configService: ConfigurationService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only apply in test mode
    if (!environment.testMode) {
      return next.handle(req);
    }

    // Skip TestToken endpoint to avoid infinite loop
    if (req.url.includes('TestToken')) {
      return next.handle(req);
    }

    // Get token from localStorage
    const token = this.getTokenFromLocalStorage();

    if (!token) {
      return next.handle(req);
    }

    // Check if request is to the API endpoint (supports both localhost:5000 and localhost:5001)
    try {
      const apiEndpoint = this.configService.getConfig().apiServiceEndpoint;
      const apiHost = new URL(apiEndpoint).host;
      if (req.url.includes(`${apiHost}/v1/`)) {
        console.log(`[TestTokenInterceptor] Adding token to request: ${req.url}`);
        const authReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
        return next.handle(authReq);
      }
    } catch (error) {
      // Fallback: check for common localhost patterns if config parsing fails
      if (req.url.includes('localhost:5000/v1/') || req.url.includes('localhost:5001/v1/')) {
        console.log(`[TestTokenInterceptor] Adding token to request (fallback): ${req.url}`);
        const authReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
        return next.handle(authReq);
      }
    }

    return next.handle(req);
  }

  private getTokenFromLocalStorage(): string | null {
    // Look for MSAL access token in localStorage
    const keys = Object.keys(localStorage);
    const accessTokenKey = keys.find(
      key => key.includes('accesstoken') && key.includes('6b79bf94-8a9e-4a78-ad23-de2e7dc13ee3'),
    );

    if (accessTokenKey) {
      const tokenData = JSON.parse(localStorage.getItem(accessTokenKey) || '{}');
      return tokenData.secret || null;
    }

    return null;
  }
}
